<script>

import {BButton} from 'bootstrap-vue'
import {faEdit} from '@fortawesome/free-solid-svg-icons'

export default {
  components: {
    BButton,
  },
  props: {
    packageDescriptor: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      iconEdit: faEdit,
    }
  }
}
</script>
<template>
  <b-button
    v-if="!!packageDescriptor.id"
    :to="{name: 'PackageDescriptorUpdate', params: {id: packageDescriptor.id}}"
    :title="$t('button.edit')"
    variant="link"
  >
    {{ packageDescriptor.name }}
    <font-awesome-icon :icon="iconEdit" />
  </b-button>
</template>
